const FieldType = {
    String : 1,
    Int32 : 2,
    Decimal : 3,
    TimeSpan : 4,
    Boolean : 6,
    Date : 7,
    DateTime : 8,
    BigInt : 9,
    Double : 10,
    DateTimeOffset : 11,
    Person : 1000,
    File : 1002,
    UserAction : 2000,
    Link : 3000
} as const;

export default FieldType; 
